import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mx-12 my-2" }
const _hoisted_2 = { key: 0 }

import { ref, computed, onMounted } from 'vue'
import { useCatalogsStore } from '@/store/catalogs'
import { useClientTypeStore } from '@/store/clientTypes'

import CatalogTable from './CatalogTable.vue'
import ClientTypeList from './ClientTypeList.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogsContainer',
  setup(__props) {

const catalogsStore = useCatalogsStore()
const clientTypeStore = useClientTypeStore()
const currentTab = ref('')

const refreshAll = async () => {
  await Promise.all([
    catalogsStore.fetchCatalogs(),
    clientTypeStore.fetchClientTypes({})
  ])
  if (!currentTab.value && allTabs.value.length > 0) {
    currentTab.value = allTabs.value[0].key
  }
}

onMounted(refreshAll)

const allTabs = computed(() => {
  // Catálogos dinámicos
  const catalogTabs = (catalogsStore.catalogs || []).map((cat: any) => ({
    key: 'catalog_' + cat.id,
    label: cat.name,
    type: 'catalog',
    catalogId: cat.id
  }))
  // Endpoints especiales
  const specialTabs = [
    { key: 'clientTypes', label: 'Tipos de Cliente', type: 'clientTypes' }
    // Aquí puedes agregar más endpoints si quieres
  ]
  return [...specialTabs,...catalogTabs]
})

const currentTabComponent = computed(() => {
  const tab = allTabs.value.find(t => t.key === currentTab.value)
  if (!tab) return null
  if (tab.type === 'catalog') return CatalogTable
  if (tab.type === 'clientTypes') return ClientTypeList
  return null
})

const currentTabProps = computed(() => {
  const tab = allTabs.value.find(t => t.key === currentTab.value) as any
  if (!tab) return {}
  if (tab.type === 'catalog') {
    return {
      catalog: catalogsStore.catalogs.find((c: any) => c.id === tab.catalogId) || tab
    }
  }
  return {}
})

const currentTabKey = computed(() => {
  const tab = allTabs.value.find(t => t.key === currentTab.value)
  return tab ? tab.key : ''
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      modelValue: currentTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTabs.value, (tab) => {
          return (_openBlock(), _createBlock(_component_v_tab, {
            key: tab.key,
            value: tab.key
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tab.label), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (currentTab.value && currentTabComponent.value && currentTabKey.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(currentTabComponent.value), _mergeProps({ key: currentTabKey.value }, currentTabProps.value, { onUpdate: refreshAll }), null, 16))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})